import {URL_CONFIG} from "config";

export const REQUEST_CONFIG = {
    URL: `${URL_CONFIG.URL}:${URL_CONFIG.API_PORT}/api/${URL_CONFIG.API_VERSION}`,
};

export default REQUEST_CONFIG;
